import React, { useState, useRef, useEffect } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import Header from '../components/Header';
import { NavLink } from 'react-router-dom';
import Seo from '../components/Seo';
import { useTranslation } from 'react-i18next';

function Contact() {
    const { t } = useTranslation();

    const REACT_APP_SITE_KEY = process.env.REACT_APP_SITE_KEY;

    const captchaRef = useRef(null);
    const [response, setResponse] = useState(null);
    const [fname, onChangeName] = useState("");
    const [lname, onChangeSurname] = useState("");
    const [email, onChangeEmail] = useState("");
    const [message, onChangeMessage] = useState("");
    const [phone, onChangePhone] = useState("");
    const [isAccepted, onClickTerms] = useState(false);
    const [isDisabled, onClickSend] = useState(false);

    useEffect(() => {
        if (response) {
            setTimeout(() => {
                setResponse(null);
            }, 5000);
        }
    }, [response]);

    const onClickHandeTerms = () => {
        if (isAccepted) {
            onClickTerms(false);
            onClickSend(false);
        } else {
            onClickTerms(true);
            onClickSend(true);
        }
    }

    const handleFormSubmit = e => {
        e.preventDefault();
        onClickSend(false);
        fetch(process.env.REACT_APP_SITE_URL + "PageBE/SendEmail", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                FirstName: fname,
                LastName: lname,
                Email: email,
                Phone: phone,
                Message: message,
                Accepted: isAccepted
              })
        })
        .then(async response => {
            if (response.ok) {
                setResponse({ message: t("SentOk"), success: true });
            } else {
                setResponse({ message: t("SentNotOk"), success: false });
            }
        })
    };

    return (
        <>
              <Seo
        title={"Contact us | Feeling Italy"}
        description={"Get in touch with Feeling Italy, the leading company for luxury Mediterranean villa rentals and authentic lifestyle experiences on the Amalfi Coast. Our travel designers are here to assist you with your travel needs and interests."}
        keywords={"Contact Feeling Italy, Luxury villa rentals Amalfi Coast, Mediterranean vacation homes, Sorrento villa rentals, Italian holiday properties, Concierge services Italy, Amalfi Coast travel assistance, Exclusive Mediterranean retreats, Villa booking inquiries, Personalized travel experiences Italy"}
        url={window.location.href}
      />
            <Header background={"white"} />
            <div className="background-white contactForm">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h1 className="mb-5 text-center text-black title text-uppercase">Contact Information</h1>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-md-10 col-12">
                            <div className="borderContact">
                                <span className="infoTitle">Phone</span>
                                <span className="float-end infoText"><a href="tel:+3908119312378">+39 081 193 123 78</a></span>
                            </div>
                        </div>
                        <div className="col-md-10 col-12">
                            <div className="borderContact">
                                <span className="infoTitle">Mail</span>
                                <span className="float-end infoText"><a href="mailto:info@feelingitaly.com">info@feelingitaly.com</a></span>
                            </div>
                        </div>
                        <div className="col-md-10 col-12">
                            <div className="borderContact">
                                <span className="infoTitle">Address</span>
                                <span className="float-end infoText">Corso Sant'Agata 62, 80061 Massa Lubrense, Italy</span>
                            </div>
                        </div>
                    </div>
                    <form action="#">
                        <div className="row justify-content-center inputField mt-10 mt-xs-5">
                            <div className="col-md-5 col-12 mb-3">
                                <div className="form-floating">

                                    <input type="text" className="form-control" placeholder="First Name" value={fname} onChange={(x) => onChangeName(x.target.value)} required />
                                    <label htmlFor="fname">First Name*</label>
                                </div>
                            </div>
                            <div className="col-md-5 col-12 mb-3">
                                <div className="form-floating">

                                    <input type="text" className="form-control" placeholder="Last Name" value={lname} onChange={(x) => onChangeSurname(x.target.value)} required />
                                    <label htmlFor="lname">Last Name*</label>
                                </div>
                            </div>

                            <div className="col-md-5 col-12 mb-3">
                                <div className="form-floating">

                                    <input type="text" className="form-control" placeholder="Email" value={email} onChange={(x) => onChangeEmail(x.target.value)} required />
                                    <label htmlFor="email">Email*</label>
                                </div>
                            </div>
                            <div className="col-md-5 col-12 mb-3">
                                <div className="form-floating">

                                    <input type="text" className="form-control" placeholder="Phone Number" value={phone} onChange={(x) => onChangePhone(x.target.value)} />
                                    <label htmlFor="phone">Phone Number</label>
                                </div>
                            </div>


                            <div className="col-md-10 col-12 mt-5 mb-3">
                                <div className="form-floating textarea">
                                    <input type="text" className="form-control" placeholder="Message" value={message} onChange={(x) => onChangeMessage(x.target.value)} />
                                    <label htmlFor="message">Message</label>
                                </div>
                            </div>

                            <div className="col-md-10 col-12 m-0">
                                <p className="paragraph text-black m-0">
                                    <input type="checkbox" className="m-0 me-2" value={isAccepted} onClick={(x) => onClickHandeTerms()} />
                                    I accept the <NavLink to="/privacy-policy" className="link lineEffectBlack">Privacy Policy</NavLink> and <NavLink to="/terms-conditions" className="link lineEffectBlack">Terms & Conditions</NavLink>.
                                </p>
                            </div>
                            <div className="col-md-10 col-12 text-right">
                            <div className="row">
                                <div className="col-md-12 col-12 textAlignMailSent">{response != null && <p>{response?.message}</p>} </div>
                                <div className="col-md-12 col-12"><button  onClick={e => handleFormSubmit(e)} className={"buttonSend lineEffectBlack text-uppercase mr-30 " + (!isDisabled ? "disabledSend" : "" )}>Send</button></div>                                </div>
                                <div className="invisible">
                                    <ReCAPTCHA sitekey={REACT_APP_SITE_KEY} ref={captchaRef} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Contact;
